// ACMAD long-range (seasonal) forecast helpers. The forecast is issued per
// 3-month rolling season; the season code is derived from the analysis month,
// mirroring `FORECAST_PERIODS` in data_api/api/handle_reporting.py.

const FORECAST_PERIODS = {
  1: "JFM",
  2: "FMA",
  3: "MAM",
  4: "AMJ",
  5: "MJJ",
  6: "JJA",
  7: "JAS",
  8: "ASO",
  9: "SON",
  10: "OND",
  11: "NDJ",
  12: "DJF",
};

/**
 * @param {string|number} month 1-12
 * @returns {string|null} 3-letter season code, e.g. "ASO"
 */
export function forecastPeriodFor(month) {
  return FORECAST_PERIODS[Number(month)] || null;
}

// Tercile probability categories, driest → wettest, with the report palette.
export const FORECAST_CATEGORIES = [
  { key: "Below Normal", color: "#E23B2E" },
  { key: "Normal to Below", color: "#F58220" },
  { key: "Normal to Above", color: "#4FC3F7" },
  { key: "Above Normal", color: "#1976D2" },
];

// UNWDC wet/dry classes, driest → wettest.
export const UNWDC_CATEGORIES = [
  { key: "Driest", color: "#8B0000" },
  { key: "Drier", color: "#E23B2E" },
  { key: "Dry", color: "#F58220" },
  { key: "Wet", color: "#4FC3F7" },
  { key: "Wetter", color: "#1976D2" },
  { key: "Wettest", color: "#0D47A1" },
];
